
import React from 'react';

import LocationSelect from 'components/LocationSelect';

const EventLocation = ({ location, setLocation }) => {
  return (
    <LocationSelect
      location={location}
      setLocation={setLocation}
      name="Location"
    />
  );
};

export default EventLocation;
